import { FETCH_AND_PARSE_SCHEMA, FETCH_SCHEMA, PARSE_AND_SET_SCHEMA, SET_JOB_ELEMENT_ERRORS, SET_JOB_ELEMENTS_VALUES, SET_PARSED_SCHEMA, SET_SCHEMA, SET_SCHEMA_ELEMENT_VALUE, SET_TASK_ELEMENT_ERRORS, SET_TASK_ELEMENTS_VALUES, STORE_EDITOR_REFERENCES, UPDATE_JOB_ELEMENTS_VALUES, UPDATE_SCHEMA_ELEMENT_VALUE, UPDATE_TASK_ELEMENTS_VALUES } from "./availableActions";
export var setSchema = function (payload) { return ({
    type: SET_SCHEMA,
    payload: payload,
}); };
export var setParsedSchema = function (payload) { return ({
    type: SET_PARSED_SCHEMA,
    payload: payload,
}); };
export var fetchSchema = function (payload) { return ({
    type: FETCH_SCHEMA,
    payload: payload,
}); };
export var fetchAndParseSchema = function (payload) { return ({
    type: FETCH_AND_PARSE_SCHEMA,
    payload: payload,
}); };
export var parseAndSetSchema = function (payload) { return ({
    type: PARSE_AND_SET_SCHEMA,
    payload: payload,
}); };
export var setSchemaElementValue = function (payload) { return ({
    type: SET_SCHEMA_ELEMENT_VALUE,
    payload: payload,
}); };
export var updateSchemaElementValue = function (payload) { return ({
    type: UPDATE_SCHEMA_ELEMENT_VALUE,
    payload: payload,
}); };
export var setTaskElementErrors = function (payload) { return ({
    type: SET_TASK_ELEMENT_ERRORS,
    payload: payload,
}); };
export var setJobElementErrors = function (payload) { return ({
    type: SET_JOB_ELEMENT_ERRORS,
    payload: payload,
}); };
export var setTaskElementsValues = function (payload) { return ({
    type: SET_TASK_ELEMENTS_VALUES,
    payload: payload,
}); };
export var updateTaskElementsValues = function (payload) { return ({
    type: UPDATE_TASK_ELEMENTS_VALUES,
    payload: payload,
}); };
export var setJobElementsValues = function (payload) { return ({
    type: SET_JOB_ELEMENTS_VALUES,
    payload: payload,
}); };
export var updateJobElementsValues = function (payload) { return ({
    type: UPDATE_JOB_ELEMENTS_VALUES,
    payload: payload,
}); };
export var storeEditorReferences = function (payload) { return ({
    type: STORE_EDITOR_REFERENCES,
    payload: payload,
}); };
